import React, { useEffect, useState } from 'react';
import SEOHead from '@/components/marketing/SEOHead';
import PageHeader from '@/components/marketing/PageHeader';
import CTASection from '@/components/marketing/CTASection';
import BlogCard from '@/components/marketing/BlogCard';
import { SkeletonCardLight } from '@/components/transitions/Skeleton';
import CenterRouteLoader from '@/components/transitions/CenterRouteLoader';
import { breadcrumbJsonLd } from '@/lib/jsonld';
import { api } from '@/lib/api';

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blog/posts')
      .then((r) => setPosts(r.data.posts || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  const jsonLd = breadcrumbJsonLd([
    { label: 'Home', path: '/' },
    { label: 'Blog' },
  ]);

  return (
    <>
      <SEOHead path="/blog" jsonLd={jsonLd} />
      <PageHeader
        breadcrumbs={[{ label: 'Blog' }]}
        eyebrow="Insights"
        title="Playbooks for performance teams"
        subtitle="Practical guides on traffic formats, GEO testing, source-level optimization, and compliant scaling."
      />
      <section className="bg-[#F5F7FB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          {loading ? (
            <>
              <div
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
                data-testid="blog-list-skeleton"
              >
                {Array.from({ length: 6 }).map((_, i) => (
                  <SkeletonCardLight key={i} className="h-[260px]" />
                ))}
              </div>
              <CenterRouteLoader />
            </>
          ) : posts.length === 0 ? (
            <p className="text-center text-slate-500 py-10">No posts yet. Check back soon.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => <BlogCard key={p.slug} post={p} />)}
            </div>
          )}
        </div>
      </section>
      <CTASection />
    </>
  );
}
